<div class="filter-more-item">
  <label class="upper-label" (click)="mySelect.open()">Square feet</label>

  <div class="inline-grid gap-x-3 grid-cols-2 w-full">
    <div class="label label-col2">
      <app-shared-input label="Min" [selector]="true" [value]="minValue">
        <mat-select
          #mySelect
          (selectionChange)="handleChange()"
          [(ngModel)]="minValue"
          [ngClass]="{
            'select-placeholder': minValue === 0
          }"
        >
          <mat-option [value]="0">No min</mat-option>
          <mat-option *ngFor="let option of options" [value]="option">
            {{ option | number }} sqft
          </mat-option>
        </mat-select>
      </app-shared-input>
    </div>

    <div class="label label-col2">
      <app-shared-input label="Max" [selector]="true" [value]="maxValue">
        <mat-select
          (selectionChange)="handleChange()"
          [(ngModel)]="maxValue"
          [ngClass]="{
            'select-placeholder': maxValue === 0
          }"
        >
          <mat-option [value]="0">No max</mat-option>
          <ng-container *ngFor="let option of options">
            <mat-option *ngIf="minValue <= option" [value]="option">
              {{ option | number }} sqft
            </mat-option>
          </ng-container>
        </mat-select>
      </app-shared-input>
    </div>
  </div>
</div>
